import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { hideProductPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"

// Components
import LazyRender from "@ng-mw/reol/components/LazyRender"
import { ProductDetails } from "@ng-mw/shared-react-components/lazy-loaders"
import Popup, { PopupContent } from "@modules/popup/Popup"

const ProductPopup = () => {
    const dispatch = useDispatch<any>()
    const isOpen = useSelector((state: RootState) => state.app.productPopup.visible)
    const productTitle = useSelector((state: RootState) => state.productDetails.data?.title)

    const handleClose = () => {
        dispatch(hideProductPopup())
    }

    return (
        <Popup
            isOpen={isOpen}
            isTitleHidden
            onClose={handleClose}
            title={productTitle}
        >
            <PopupContent>
                <LazyRender
                    isVisible={isOpen}
                    hiddenClassName=""
                >
                    <ProductDetails
                        isBig={false}
                        isBreadcrumbHidden
                    />
                </LazyRender>
            </PopupContent>
        </Popup>
    )
}
export default ProductPopup
